import { reactive } from 'vue'

export interface FloatValueInitOption {
  type: string
  name: string
  autoModal: {
    title: string
    width?: number
    heightLayout?: 'auto' | 'fixed'
    destroyOnClose?: boolean
    maskClosable?: boolean
    show: unknown[]
    menu?: ('hide' | 'okAndHide' | 'ok')[]
    event: (act: string, modal: any, data: any, payload?: any) => void
  }
  props: Record<PropertyKey, unknown>
  event?: (act: string, item: any, ...args: unknown[]) => void
  component: () => any
}

let id = 1

export class FloatValue {
  id: number
  type: string
  name: string
  autoModal: FloatValueInitOption['autoModal']
  props: Record<PropertyKey, unknown>
  event?: (act: string, item: any, ...args: unknown[]) => void
  show: boolean
  init: boolean
  component: () => any
  constructor(initOption: FloatValueInitOption, show = true) {
    this.id = id++
    this.type = initOption.type
    this.name = initOption.name
    this.autoModal = initOption.autoModal
    this.props = initOption.props
    this.event = initOption.event
    this.component = initOption.component
    this.show = show
    this.init = false
  }
  destroy() {
    //
  }
}

const floatData = reactive({
  list: [] as FloatValue[],
  push(valueInitOption: FloatValueInitOption) {
    this.list.push(new FloatValue(valueInitOption))
  },
  remove(item: FloatValue) {
    const index = this.list.indexOf(item)
    this.list.splice(index, 1)
    return index
  },
  replace(item: FloatValue, newInitOption?: Partial<FloatValueInitOption>, show?: boolean) {
    const newItem = new FloatValue({
      ...item,
      ...newInitOption
    }, show)
    const index = this.list.indexOf(item)
    this.list.splice(index, 1, newItem)
  }
})

export default floatData
